import React, { Component } from "react";

import PreviousTranslations from '../previous-translations/previous-translations.component';
import TagsSelect from "../tags-select/tags-select.component";
import DragNDropUpload from "../dran-n-drop-upload/drag-n-drop-upload.component";
import CategoriesSelect from "../categories-select/categories-select.component";
import { KEY_STATUS } from '../../enums/key-status';

import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './add-translation-form.styles.scss';

let Inline = Quill.import('blots/inline');

class BoldBlot extends Inline { }
BoldBlot.blotName = 'bold';
BoldBlot.tagName = 'b';
Quill.register('formats/bold', BoldBlot);

const formats = ["bold", "italic", "underline", "link"];
const modules = {
    toolbar: [
        ["bold", "italic", "underline", "link"],
    ]
};

class AddTranslationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      translationKey: null,
      translationText: '',
      charactersLimit: 0,
      indications: '',
      photos: [],
      isMarketing: false,
      deadline: null,
      translationLanguages: [],
      previousTranslations: [],
      allLanguagesSelected: true,
      tags: [],
      platformTags: [],
      categories: [],
      forceReload: false,
      submitLoader: false,
      errors: {
        translationKey: {
          invalid: false,
          message: 'The translation key is required'
        },
        translationText: {
          invalid: false,
          message: 'English text is required'
        },
        tags: {
          invalid: false,
          message: 'Please select at least one tag'
        },
        form: {
          invalid: false,
          message: ''
        }
      },
    }
    this.removePreview = this.removePreview.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    const languages = props.languageList.map(({tag}) => tag)
    if(state.loaded === false && state.translationLanguages.length === 0) {
        // Change in props
        return {
          translationLanguages: languages,
        };
    }
    return null; // No change to state
  }

  componentDidMount() {
    this.setState({loaded: true})
  }

  handleAddLanguage = (e) => {
    const {translationLanguages} = this.state;
    if (e.target.checked) {
      let languages = [...translationLanguages];
      languages.push(e.target.value);
      this.setState({translationLanguages: languages}, this.handleAllLanguagesState)
    } else {
      const langs = translationLanguages.filter(tag => tag !== e.target.value);
      this.setState({translationLanguages: langs}, this.handleAllLanguagesState)
    }
  }

  handleAllLanguagesState = () => {
    const {translationLanguages} = this.state;
    const {languageList } = this.props;
    if(translationLanguages.length !== languageList.length) {
      this.setState({allLanguagesSelected: false})
    } else {
      this.setState({allLanguagesSelected: true})
    }
  }

  handleIsMarketingChange = (e) => {
    const isChecked = e.target.checked
    this.setState({isMarketing: isChecked})
    if (isChecked) {
      this.setState({translationLanguages: [], allLanguagesSelected: false})
    } else {
      const { languageList } = this.props;
      this.setState({translationLanguages: languageList.map(({tag}) => tag)}, this.handleAllLanguagesState)
    }
  }

  handleToggleAllLanguages = (e) => {
    const isChecked = e.target.checked;
    const { languageList } = this.props;
    if (isChecked) {
      this.setState({allLanguagesSelected: true, translationLanguages: languageList.map(({tag}) => tag)})
    } else {
      this.setState({allLanguagesSelected: false, translationLanguages: []})
    }
  }
  resetErrors = () => {
    const errors = {
      translationKey: {
        invalid: false,
        message: 'The translation key is required'
      },
      translationText: {
        invalid: false,
        message: 'English text is required'
      },
      tags: {
        invalid: false,
        message: 'Please select at least one tag'
      },
      form: {
        invalid: false,
        message: ''
      }
    };
    this.setState({'errors': errors});
  }


  setPhotos(values) {
    const {photos} = this.state
    const newPhotos = photos.concat(Array.from(values));

    this.setState({photos: newPhotos})
  }

  setFieldValue(field, value) {
    this.setState({[field]: value})
  }

  isLanguageSelected(tag) {
    const {isMarketing, translationLanguages} = this.state;
    if(translationLanguages.includes(tag)) {
      return true;
    }

    return false;
  }

  onSubmit = async (status) => {
    this.resetErrors();
    const {
      translationKey,
      isMarketing,
      translationText,
      tags,
      platformTags,
      categories,
      translationLanguages,
      previousTranslations,
      indications,
      deadline,
      charactersLimit,
      photos
    } = this.state;

    if ((!translationKey && !isMarketing && status === KEY_STATUS.PUBLISHED)) {
      const {errors} = this.state;
      const err = { ...errors, translationKey: { ...errors.translationKey, invalid: true }};
      this.setState({errors: err})

      return false;
    }

    let sanitizedText = translationText ? translationText.replace(/(<p>)/g, ''): '';
    sanitizedText = sanitizedText.replace(/(<\/p>|<br>|<br\/>)/g, '\n');

    const index = sanitizedText.lastIndexOf('\n');
    if(index !== -1) {
      sanitizedText = sanitizedText.substring(0, index);
    }

    if (sanitizedText.length < 1) {
      const {errors} = this.state;
      const err = { ...errors, translationText: { ...errors.translationText, invalid: true }};
      this.setState({errors: err})

      return false;
    }

    if (tags.length === 0) {
      const {errors} = this.state;
      const err = { ...errors, tags: { ...errors.tags, invalid: true }};
      this.setState({errors: err})

      return false;
    }

    //combined tags
    const combinedTags = tags.concat(platformTags);
    const tagList = combinedTags.map((t) => {
      let mapped = {
        name: t.label
      };
      if (!t.__isNew__) {
        mapped.id = t.value;
      }

      return mapped;
    });

    const categoryList = categories.map((c) => {
      let mapped = {
        name: c.label
      };
      if (!c.__isNew__) {
        mapped.id = c.value;
      }

      return mapped;
    });

    const translationLanguagesList = translationLanguages.map((l) => {
      return {
        tag: l
      };
    });

    const prevTranslations = previousTranslations.map((translation) => translation.value).toString();
    const formData = new FormData();
    formData.append('translationKey', translationKey);
    formData.append('translationStatus', status);
    formData.append('translationText', sanitizedText);
    formData.append('charactersLimit', charactersLimit);
    formData.append('indications', indications);
    formData.append('previousTranslations', prevTranslations);
    formData.append('languages', JSON.stringify(translationLanguagesList));
    photos.forEach(photo => {
      formData.append('photos[]', photo, photo.name);
    });

    formData.append('isMarketing', isMarketing);
    formData.append('tags', JSON.stringify(tagList));
    formData.append('categories', JSON.stringify(categoryList));

    if (deadline) {
      formData.append('deadline', deadline);
    }

    const {createTranslation, reloadKeysLeftPanel} = this.props;
    this.setState({submitLoader: true});
    createTranslation(formData).then(result => {
      if (result.success) {
        this.setState({
          translationKey: null,
          translationText: null,
          charactersLimit: 0,
          indications: '',
          photos: [],
          isMarketing: false,
          deadline: null,
          translationLanguages: [],
          previousTranslations: [],
          tags: [],
          categories: [],
          loaded: false,
          allLanguagesSelected: true,
          forceReload: true,
          submitLoader: false,
        });
        const {hideForm} = this.props;
        hideForm();

        //reload keys left sidebar
        reloadKeysLeftPanel();
      } else {
        const {errors} = this.state;
        const err = { ...errors, form: { ...errors.form, invalid: true, message: result.error }};
        this.setState({errors: err, submitLoader: false})
      }
    });
  }

  removePreview(photoIndex) {
    const {photos} = this.state
    photos.splice(photoIndex, 1);
    this.setState({photos: photos})
  }

  closeForm = () => {
    const {hideForm} = this.props;
    hideForm();
  }

  renderActionButtons() {
    const { submitLoader } = this.state;
    if(!submitLoader) {
      return (
        <>
          <button className="btn btn-mondly btn-outline-blue" onClick={() => { this.onSubmit(KEY_STATUS.DRAFT) }}>Save as draft</button>
          <button className="btn btn-mondly btn-blue" onClick={() => { this.onSubmit(KEY_STATUS.PUBLISHED) }}>Publish</button>
        </>
      );
    } else {
        return <div className="loader"></div>
    }
  }

  render() {
    const {
      isMarketing,
      errors,
      charactersLimit,
      translationKey,
      translationText,
      indications,
      deadline,
      allLanguagesSelected,
    } = this.state;
    const translationKeyValue = translationKey || '';
    const { languageList } = this.props;

    return (
      <div className="row">
        <div className="col-12 mt-3">
          <div className="custom-control custom-switch form-group">
            <input type="checkbox" className="custom-control-input" id="is-marketing-key" onChange={ this.handleIsMarketingChange } />
            <label className="custom-control-label" htmlFor="is-marketing-key">This text is for Marketing team</label>
          </div>
          {!isMarketing &&
            <div className="form-group">
              <label className="translation-section-title text-muted" htmlFor="translationKey">Translation Key <span className={'text-danger'}>*</span></label>
              <input type="text" className={`form-control ${errors.translationKey.invalid ? 'is-invalid' : ''}`} id="translationKey" onChange={e => this.setFieldValue('translationKey', e.target.value)} value={translationKeyValue} />
              {errors.translationKey.invalid && <div className="invalid-feedback">{errors.translationKey.message}</div>}
            </div>}
          <div className="form-group">
            <label className="translation-section-title text-muted" htmlFor="translationText">Add text to be translated <span className={'text-danger'}>*</span></label>
            <ReactQuill
              id="translationText"
              className={`light-container ${errors.translationText.invalid ? 'is-invalid' : ''}`}
              theme="snow"
              defaultValue={translationText ? translationText : ""}
              value={translationText ? translationText : ""}
              placeholder={"Add translation here"}
              rows={3}
              modules={modules}
              formats={formats}
              onChange={(value) => this.setFieldValue('translationText', value)}/>
            {errors.translationText.invalid && <div className="invalid-feedback">{errors.translationText.message}</div>}
          </div>

          <div className="form-group">
            <label className="translation-section-title text-muted" htmlFor="charactersLimit">Characters limit</label>
            <input type="number" className='form-control' id="charactersLimit" onChange={e => this.setFieldValue('charactersLimit', e.target.value)} value={charactersLimit} />
          </div>
          <div className="form-group">
            <label className="translation-section-title text-muted" htmlFor="translationLanguages">Languages</label>
            <div className="custom-control custom-checkbox mb-2">
              <input type="checkbox" className="custom-control-input" id={`language-all`} value={'all'} onChange={ this.handleToggleAllLanguages } checked={allLanguagesSelected}/>
              <label className="custom-control-label" htmlFor={`language-all`}>All</label>
            </div>
            <div className="language-columns">
              {languageList.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)).map((language, index) => (
                <div className="custom-control custom-checkbox" key={language.name}>
                  <input type="checkbox" className="custom-control-input" id={`language-${index}`} value={language.tag} onChange={ this.handleAddLanguage } checked={this.isLanguageSelected(language.tag)}/>
                  <label className="custom-control-label" htmlFor={`language-${index}`}>{language.name}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="form-group">
            <label className="translation-section-title text-muted" htmlFor="indications">Indications</label>
            <ReactQuill
              id="indications"
              className={`light-container`}
              theme="snow"
              defaultValue={indications ? indications : ""}
              value={indications ? indications : ""}
              placeholder={"Add indications here"}
              rows={3}
              modules={modules}
              formats={formats}
              onChange={(value) => this.setFieldValue('indications', value)}/>
          </div>
          <div className="form-group">
            <label className="translation-section-title text-muted" htmlFor="deadline">Deadline</label>
            <input type="date" className='form-control' id="deadline" onChange={(e) => this.setFieldValue('deadline', e.target.value)} value={deadline || 'mm/dd/yyy'} />
          </div>
          {isMarketing && <div className="form-group">
            <CategoriesSelect selectedItems={[]} showLabel={true} onChange={(values) => { this.setFieldValue('categories', values) }} />
          </div>}
          {!isMarketing && <div className="form-group">
            <PreviousTranslations selectedItems={[]} onChange={(values) => { this.setFieldValue('previousTranslations', values) }} />
          </div>}
          <div className="form-group">
            <TagsSelect selectedItems={[]} showLabel={true} onChange={(values) => { this.setFieldValue('tags', values) }} isMandatory={true} />
            {errors.tags.invalid && <div className="hasError"><div className="invalid-feedback">{errors.tags.message}</div></div>}
          </div>
          <div className="form-group">
            <TagsSelect selectedItems={[]} showLabel={true} onChange={(values) => { this.setFieldValue('platformTags', values) }} hasPlatformTags={true} />
          </div>
          <DragNDropUpload onChange={(item) => this.setPhotos(item)} autoSubmit={false} showPreviewContainer={true} removePreview={this.removePreview} />
          {errors.form.invalid ?
            <div className="form-group hasError">
              {errors.form.invalid && <div className="invalid-feedback">{errors.form.message}</div>}
            </div>
          :null}
          <div className="modal-footer">
            {this.renderActionButtons()}
          </div>
        </div>
      </div>
    );
  }
}

export default AddTranslationForm;
